import { render } from "./DashboardLeaveRequests.vue?vue&type=template&id=0e407d64&scoped=true"
import script from "./DashboardLeaveRequests.vue?vue&type=script&lang=js"
export * from "./DashboardLeaveRequests.vue?vue&type=script&lang=js"

import "./DashboardLeaveRequests.vue?vue&type=style&index=0&id=0e407d64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e407d64"]])

export default __exports__